module.exports = __webpack_public_path__ + "img/ep.8ec1ca35.jpg";